const CHANNEL = 'olsior'
const MAX_MESSAGES = 50

// Підключення до чату Twitch через tmi.js — незалежно від того, чи
// відкритий/завантажений iframe вбудованого чату. Дозволяє рахувати
// непрочитані повідомлення та показувати бабли з чату, коли він закритий.
export const useTwitchChat = () => {
  const messages = useState('twitchChatMessages', () => [])
  const unreadCount = useState('twitchChatUnread', () => 0)
  const connected = useState('twitchChatConnected', () => false)
  const isOpen = useState('twitchChatOpen', () => false)

  if (import.meta.client) {
    let client = null

    const connect = async () => {
      if (client) return

      try {
        const { Client } = await import('tmi.js')
        client = new Client({ channels: [CHANNEL] })

        client.on('message', (_channel, tags, text, self) => {
          if (self) return

          messages.value = [
            ...messages.value.slice(-(MAX_MESSAGES - 1)),
            {
              id: tags.id || `${Date.now()}-${Math.random()}`,
              author: tags['display-name'] || tags.username || 'anon',
              color: tags.color || '#9147ff',
              text
            }
          ]

          if (!isOpen.value) unreadCount.value++
        })

        client.on('connected', () => {
          connected.value = true
        })
        client.on('disconnected', () => {
          connected.value = false
        })

        await client.connect()
      } catch (e) {
        console.error('[useTwitchChat] connection failed', e)
      }
    }

    onMounted(connect)

    onBeforeUnmount(() => {
      if (client) {
        client.disconnect().catch(() => {})
        client = null
      }
    })

  }

  // Скидати лічильник — справа того, хто показує чат: після поділу кнопок
  // відкрите вікно загального чату сайту вже не означає, що прочитали Twitch
  return { messages, unreadCount, connected }
}
